
import { OedsPerson, EmailList, State, AddressList, PhoneList, OrgCollection } from '../models/contact-oeds-person.model';
import { TokenResponse } from '../models/contact-token.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContactVerificationService {
  isBackNav = false;
  isFromHeadIcon = false;
  isHomeEmailRequired: boolean = null;
  isOfficeEmailRequire: boolean=null;
  isOhidEmailChanged = false;
  _stepCount: number = 0;
  get stepCount(): number {
      return this._stepCount;
  }
  set stepCount(value: number) {
     this._stepCount = value;
  }
  oaksId: string = "";
  personkey: string = "";
  homeEmailOption: string = "home-1";
  officeEmailOption: string = "office-1";
  existingHomeEmail: string = "";
  reEnterExHomeEmail: string = "";
  existingOfficeEmail: string = "";
  reEnterExOfficeEmail: string = "";
  stepperList: any = null;
  contactVerificationFailed: boolean = false;
  contactVerificationFailedMsg: string = "";
  isUserTiedToMutipleOrgs: boolean = false;
  isUserOrgMappingExist: boolean;
  isOfficeEmailRequired: boolean;
  hasOfficeEmail: boolean = false;
  hasOfficePhone: boolean = false;
  hasOfficePhysicalAddress: boolean = false;
  hasOfficeMailingAddress: boolean = false;
  action = "";
  statesList: State[] = [];
  selectedaddress: AddressList;
  selectedphone: PhoneList;
  tokenDtls: TokenResponse;
  orgList: OrgCollection[] = [];
  oedsPerson: OedsPerson;
  oedsPersonCopy: OedsPerson;
  constructor() {    
  }
  assignDefaultOedsPerson() {
    const oedspersonObj = {} as OedsPerson;
    oedspersonObj.emailList = [];
    oedspersonObj.phoneList = [];
    oedspersonObj.addressList = [];
    oedspersonObj.orgEmailList = [];
    this.oedsPerson = oedspersonObj;
  }

  backToApplication() {
    this.openCancelConfirmModal();
  }
  setStep(name) {
    let steplist = this.stepperList;
    steplist.items.forEach(item => {
      item.completed = false;
      item.current = false;
      item.selected = false;
    })
    for (let i = 0; i < steplist.items.length; i++) {
      if (steplist.items[i].label === name) {
        steplist.items[i].current = true;
        steplist.items[i].selected = true;
        break;
      }
      steplist.items[i].completed = true;
    }
    this.stepperList = { ...this.stepperList }
  }
  openCancelConfirmModal() {
    if (this.stepCount === 7) {
      this.continueBackToApplication();
    }
    else {
      var modal = document.getElementById('modal-cancel');
      modal.removeAttribute("aria-hidden");
      modal.setAttribute("class", "modal-wrapper modal-open");
    }
  }

  closeCancelConfirmModal() {
    var modal = document.getElementById('modal-cancel');
    modal.setAttribute("aria-hidden", "true");
    modal.setAttribute("class", "modal-wrapper")
  }
  continueBackToApplication() {
    if (this.isFromHeadIcon === false) {
      window.location.href = this.tokenDtls.applicationRedirectUrl;
    }
    else {
      window.location.href = "./user-profile";
    }
  }
  filterEmailByType(emailtype, objList: EmailList[]) {
    return objList.filter(function (obj) {
      return obj.oedsEmailType === emailtype;
    });
  }
  filterActiveEmailByType(emailtype, objList: EmailList[]) {
    return objList.filter(function (obj) {
      return (obj.oedsEmailType === emailtype && obj.actionType !== "Deleted");
    });
  }
  insertEmailByType(email, emailTypeKey, primaryFlag, privateFlag) {
    const oedsEmailObj = {} as EmailList;
    oedsEmailObj.oedsEmailKey = 0;
    oedsEmailObj.email = email;
    oedsEmailObj.oedsEmailType = emailTypeKey;
    oedsEmailObj.primaryFlag = primaryFlag;
    oedsEmailObj.privateFlag = privateFlag;
    oedsEmailObj.isMapped = false;
    oedsEmailObj.actionType = "Inserted";
    this.oedsPersonCopy.emailList.push(oedsEmailObj);
  }
  updateEmailByType(oedsEmailObj, email, emailTypeKey, primaryFlag, privateFlag) {
    oedsEmailObj.email = email;
    oedsEmailObj.primaryFlag = primaryFlag;
    oedsEmailObj.privateFlag = privateFlag;
    oedsEmailObj.actionType = "Updated";
  }
  deleteEmailByType(emailTypeKey) {
    //delete all emails with type
    var emails = this.oedsPersonCopy.emailList.filter(x => x.oedsEmailType === emailTypeKey);
    if (emails.length !== 0) {
      for (const item of emails) {
        if (item.oedsEmailKey !== 0) {
          item.actionType = "Deleted";
        }
        else {
          this.oedsPersonCopy.emailList = this.oedsPersonCopy.emailList.filter(i => i.oedsEmailType !== emailTypeKey);
        }
      }
    }
  }
  insertUpdateEmail(email, emailTypeKey, primaryFlag, privateFlag) {
    var exEmailObj = this.oedsPersonCopy.emailList.find(x => x.email === email && x.oedsEmailType === emailTypeKey);    
    if (!exEmailObj) {
      var item = this.oedsPersonCopy.emailList.find(x => x.oedsEmailType === emailTypeKey);
      if (this.isUserTiedToMutipleOrgs && emailTypeKey === 3) {
        var item = this.oedsPersonCopy.emailList.find(x => x.oedsEmailType === emailTypeKey && x.actionType === "Deleted" && x.primaryFlag !== true);
      }
      if (item) {
        if (item.oedsEmailKey != 0) {
          this.updateEmailByType(item, email, emailTypeKey, primaryFlag, privateFlag);
        }
        else {
          item.email = email;
          item.primaryFlag = primaryFlag;
          item.privateFlag = privateFlag;
        }
      }
      else {
        this.insertEmailByType(email, emailTypeKey, primaryFlag, privateFlag)
      }
    }
    else {
      exEmailObj.email = email;
      exEmailObj.primaryFlag = primaryFlag;
      exEmailObj.privateFlag = privateFlag;
      exEmailObj.actionType = "Updated";
    }
  }
  filterAddressByType(addressType, locType, objList: AddressList[]) {
    return objList.filter(function (obj) {
      return obj.oedsAddressType === addressType && obj.oedsLocationType === locType;
    });
  }
  filterActiveAddressByType(addressType, locType, objList: AddressList[]) {
    return objList.filter(function (obj) {
      return obj.oedsAddressType === addressType && obj.oedsLocationType === locType && obj.actionType !== "Deleted";
    });
  }
  assignDefaultAddress(address) {
    address.oedsAddressKey = 0;
    address.addressI = null;
    address.city = null;
    address.stateKey = null;
    address.state = null;
    address.zipCode = null;
    address.zipCode4 = null;
    address.isConfirm = false;
    address.hasEmptyAddress = false;
    address.actionType = "";
  }
  deleteAddressByType(addTypeKey, locTypeKey, objList: AddressList[]) {
    var addList = objList.filter(x => x.oedsAddressType === addTypeKey && x.oedsLocationType === locTypeKey);
    for (var cAddress of addList) {      
      if (cAddress.oedsAddressKey != 0) {
        cAddress.addressI = "";
        cAddress.city = "";
        cAddress.stateKey = -1;
        cAddress.state = "";
        cAddress.zipCode = "";
        cAddress.zipCode4 = "";
        cAddress.isConfirm = false;
        cAddress.actionType = "Deleted";
      }
      else {
        this.assignDefaultAddress(cAddress);
      }
    }
  }
  filterPhoneByType(phoneType, objList: PhoneList[]) {
    return objList.filter(function (obj) {
      return obj.oedsPhoneType === phoneType;
    });
  }
  filterActivePhoneByType(phoneType, objList: PhoneList[]) {
    return objList.filter(function (obj) {
      return obj.oedsPhoneType === phoneType && obj.actionType !== "Deleted";
    });
  }
  assignDefaultPhone(phone) {
    phone.oedsPhoneKey = 0;
    phone.areaCode = null;
    phone.phoneNumber = null;
    phone.primaryFlag = false;
    phone.privateFlag = false;
    phone.isConfirm = false;
    phone.actionType = "";
  }
  deletePhoneByType(phoneType, objList: PhoneList[]) {
    var phoneList = objList.filter(x => x.oedsPhoneType === phoneType);
    for (var cPhone of phoneList) {         
      if (cPhone.oedsPhoneKey !== 0) {
        cPhone.areaCode = "";
        cPhone.phoneNumber = "";
        cPhone.isConfirm = false;
        cPhone.phoneNumber = ""; 
        cPhone.actionType = "Deleted";
      }
      else {
        this.assignDefaultPhone(cPhone);
      }
    }
  }
  cleanUpJsonObject() {
    this.oedsPersonCopy.emailList = this.oedsPersonCopy.emailList.filter(x => x.actionType !== "" && (x.actionType!=="Deleted" || x.oedsEmailKey!==0));
    //PUB_LIST_FLG  N means Public PUB_LIST_FLG  Y Means Private in OEDS
    //In Ui we have taken MDM as base so here we should reverse the private flag
    this.oedsPersonCopy.emailList.map(item => { item.privateFlag = !item.privateFlag });
    this.oedsPersonCopy.addressList = this.oedsPersonCopy.addressList.filter(x => x.actionType !== "");
    this.oedsPersonCopy.phoneList = this.oedsPersonCopy.phoneList.filter(x => x.actionType !== "");
    //this.oedsPersonCopy.orgEmailList = this.oedsPersonCopy.orgEmailList.filter(x => x.email !== "" && x.email !== null);
  }
}
